import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import Loading from '../../../../components/Loading';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';
import { searchRows } from '../../GscTools/components/EvidenceBlock';
import { RECORD_COLUMNS } from '../keys';

/**
 * Block 02's expansion for a sitemap index: the sitemaps submitted inside it.
 *
 * Asked for only when the user presses the button — a list request narrowed to the index, never a
 * fetch of the index file. What comes back is submitted records, the same kind as block 01's, not
 * every URL the index's children contain; the block says so under the table.
 */
function IndexChildren({ t, record, state, onLoad }) {
    if (!record?.isIndex) return null;

    const columns = RECORD_COLUMNS(t);
    const loaded = state.status === 'done' && state.path === record.path;

    return (
        <div className="gsc-tool-details">
            <p className="card-title">{t('tools.sitemap_status.children.title')}</p>

            {!loaded && state.status !== 'loading' && (
                <>
                    <p className="gsc-tool-table-note">{t('tools.sitemap_status.children.hint')}</p>
                    <button
                        type="button"
                        className="button button-outline button-primary btn"
                        onClick={onLoad}
                    >
                        {t('tools.sitemap_status.children.load')}
                    </button>
                </>
            )}

            {state.status === 'loading' && <Loading padding={10} />}

            {state.status === 'error' && <div className="gsc-tool-banner error">{state.error}</div>}

            {loaded && (
                <>
                    <DataTable
                        nodes={state.rows}
                        COLUMNS={columns}
                        sortFns={getSortKeys(columns)}
                        additionalStyles={setAdditionalStyles(columns)}
                        searchFunction={searchRows}
                        fileName={`${t('tools.sitemap_status.children.title')} — ${record.path}`}
                        customEmptyMessage={t('tools.sitemap_status.children.empty')}
                        customContainerStyles="gsc-tool-key-table"
                    />
                    <p className="gsc-tool-table-note">{t('tools.sitemap_status.children.note')}</p>
                </>
            )}
        </div>
    );
}

export default withTranslation()(IndexChildren);
